import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'all', 'count', 'total', 'submit']
  static values = { balance: String }

  checkboxTargetConnected() {
    this.update()
  }

  checkboxTargetDisconnected() {
    this.update()
  }

  toggleAll() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = this.allTarget.checked
    })
    this.update()
  }

  update() {
    if (!this.hasTotalTarget) return

    const selected = this.selected
    const cents = this.selectedCents
    const balanceCents = Math.round(parseFloat(this.balanceValue) * 100)

    this.countTarget.textContent = selected.length
    this.totalTarget.textContent = this.format(cents)
    this.totalTarget.classList.toggle('text-red-500', cents > balanceCents)
    this.submitTarget.disabled = selected.length === 0

    if (this.hasAllTarget) {
      this.allTarget.checked = selected.length > 0 && selected.length === this.checkboxTargets.length
      this.allTarget.indeterminate = selected.length > 0 && selected.length < this.checkboxTargets.length
    }
  }

  confirmSubmit(event) {
    const cents = this.selectedCents
    const balanceCents = Math.round(parseFloat(this.balanceValue) * 100)
    let message = `Process ${this.selected.length} selected cashouts totaling ${this.format(cents)} through PayPal in one payout now?`
    if (cents > balanceCents) {
      message = `The selected total of ${this.format(cents)} is more than the available balance. ${message}`
    }

    if (!confirm(message)) {
      event.preventDefault()
      return
    }

    document.getElementById('loading-logo').classList.remove('hidden')
  }

  get selected() {
    return this.checkboxTargets.filter(checkbox => checkbox.checked)
  }

  get selectedCents() {
    return this.selected.reduce((sum, checkbox) => sum + parseInt(checkbox.dataset.cents, 10), 0)
  }

  format(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
  }
}
